@if (showSpinner) {
  <div class="app-loader">
    <div class="u-flex-center">
      <mat-spinner color="primary" diameter="50"></mat-spinner>
    </div>
  </div>
}

<div class="photo-carousel_container" [ngClass]="images.length < 1 ? 'short' : ''">
  <div class="photo-carousel_header">
    <h2 class="mat-display-medium is-component">{{ heading }}</h2>
    @if (images.length > 1) {
      <app-arrow-text-button>
        <div linkText (click)="navigateTo('recent-photos')">
          view all
        </div>
      </app-arrow-text-button>
    }
  </div>
  @if (images.length < 1) {
    <p class="mat-body-medium">No photos yet.</p>
  }
  @if (images.length >= 1) {
    <div class="photo-carousel_slider">
      <div class="swiper-photo-carousel">
        <swiper-container
          #mySwiper
          class="swiper-photo-carousel_slider"
          [init]="false"
          navigation='{ "nextEl": ".photo-carousel-swiper-button-next", "prevEl": ".photo-carousel-swiper-button-prev" }'
          (indexChange)="onIndexChange($event)"
          (click)="openPhotoPreviewModal($event)"
          (swiperTouchStart)="handleTouchStart($event)"
          (swiperTouchMoveOpposite)="swiperTouch($event)">
          @for (image of images; track image; let i = $index) {
            <swiper-slide>
              <div class="slider-item slide-item-{{ i }}">
                <div class="image" [style.background-image]="'url(' + image.medium + ')'">
                  <div class="photo-carousel_count" (click)="navigateTo('recent-photos')">
                    {{ i + 1 }} / {{ photoCount }}
                  </div>
                </div>
              </div>
            </swiper-slide>
          }
        </swiper-container>
        <div class="photo-carousel-swiper-button-prev"></div>
        <div class="photo-carousel-swiper-button-next"></div>
        <div class="thumbnails">
          @for (image of images; track image; let i = $index) {
            @if (i < 5) {
              <div class="thumbnail" [style.background-image]="'url(' + image.small + ')'">
                @if (i === 4) {
                  <span class="mat-body-medium">+{{ images.length - i }}</span>
                }
              </div>
            }
          }
        </div>
      </div>
    </div>
  }
</div>